<template>
  <div>
    <b-modal
      id="add-users-group"
      hide-footer
      no-close-on-backdrop
      title="Add user"
      @hidden="phoneNo = null"
    >
      <DriversSearch
        v-if="filterBy == 'drivers'"
        :auto-reset="false"
        :clearable="false"
        :filterable="false"
        @drivers-selection="phoneNo = $event.phoneNumber"
      />
      <UsersSearch
        v-if="filterBy == 'riders'"
        :auto-reset="false"
        :clearable="false"
        :filterable="false"
        @users-selection="phoneNo = $event.phoneNumber"
      />
      <b-button
        class="mt-1"
        block
        variant="primary"
        :disabled="!phoneNo || submitting"
        @click="addUser"
      >
        <b-spinner v-if="submitting" small />
        <span v-else>Confirm</span>
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import { BModal, BButton, BSpinner } from "bootstrap-vue";
import DriversSearch from "@/views/driver/components/DriversSearch.vue";
import UsersSearch from "@/views/users/rider/components/UsersSearch.vue";
import {
  errorNotification,
  successNotification,
} from "@/utils/toast-notifications";

export default {
  components: {
    BModal,
    DriversSearch,
    UsersSearch,
    BButton,
    BSpinner,
  },
  props: {
    filterBy: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const groupID = ctx.root.$route.params.id || ctx.root.$route.query.id;
    const phoneNo = ref(null);
    const submitting = ref(false);
    const addUser = async () => {
      try {
        submitting.value = true;
        await ctx.root.$store.dispatch("groups/addUsersToGroup", {
          groupID: groupID,
          phoneNumbers: [phoneNo.value],
        });
        successNotification("Phone number added successfully");
        ctx.emit("user-added");
        ctx.root.$bvModal.hide("add-users-group");
      } catch (error) {
        errorNotification("An error occured");
      } finally {
        submitting.value = false;
      }
    };
    return {
      addUser,
      phoneNo,
      submitting,
    };
  },
};
</script>
